<template>
  <div class="main">
    <my_menu2
      page_name="项目合同审批权限"
      back_type="close"
      back_icon="md-close"
    ></my_menu2>
    <div style="height: 50px"></div>
    <div class="content">
      <div class="table_box">
        <div
          class="dep_inner_box"
          v-for="(children_item, children_index) in team_list"
          :key="children_index"
        >
          <div class="dep_main_div">
            <div class="depname">
              {{ children_item.name }}
            </div>

            <Tag
              closable
              @on-close="click_del_user(item)"
              v-for="(item, i) in children_item.user_list"
              :key="i"
              >{{ item.name }}</Tag
            >

            <div class="add_user_btn" @click="click_user_add(children_item)">
              <Icon type="md-add-circle" />添加
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal v-model="add_user_show" title="添加用户" :footer-hide="true" width="400">
      <div>
        <Select v-model="add_select_user_id" filterable>
          <Option v-for="item in user_list" :value="item.value" :key="item.value">{{
            item.label
          }}</Option>
        </Select>
      </div>
      <div class="add_user_btn_div">
        <Button type="primary" @click="click_add_user_affirm">确认添加</Button>
      </div>
    </Modal>

    <!-- 
    <Modal
      v-model="add_user_total_show"
      title="添加用户(所有部门)"
      :footer-hide="true"
      width="400"
    >
      <div>
        <Select v-model="add_select_user_id" filterable>
          <Option v-for="item in user_list" :value="item.value" :key="item.value">{{
            item.label
          }}</Option>
        </Select>
      </div>
      <div class="add_user_btn_div">
        <Button type="primary" @click="click_add_total_user_affirm">确认添加</Button>
      </div>
    </Modal> -->
  </div>
</template>

<script>
import my_menu2 from "@/component/menu/menu2.vue";
import { http } from "@/utils/http.js";

export default {
  components: {
    my_menu2,
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      team_list: [],
      add_user_show: false,
      user_list: [],
      add_select_user_id: "",
      current_team_item: {},
    };
  },

  mounted() {
    this.window_change();
    this.get_team_list();
    this.get_user_list();
  },

  methods: {
    click_del_user(row) {
      var that = this;
      var obj = {
        id: row.id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/panel_manage/contract/del_user_auth",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_team_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
    click_add_user_affirm() {
      var that = this;
      var obj = {
        user_id: this.add_select_user_id,
        dep_team_id: this.current_team_item.dep_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/panel_manage/contract/add_user_auth",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.add_user_show=false
            that.get_team_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_user_list() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/panel_manage/xiangmu/sys_user_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.user_list = res.data.user_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_user_add(row) {
      this.add_user_show = true;
      this.current_team_item = row;
    },

    get_team_list() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_HOST + "/panel_manage/contract/team_list",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.team_list = res.data.team_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
  },
};
</script>

<style scoped>
.depname {
  width: 100px;
  flex-shrink: 0;
}

.tabs_div {
  padding: 0 10px;
}

.add_user_btn_div {
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
}

.depname {
  font-weight: 600;
  font-size: 13px;
  padding: 5px 5px;
  border-radius: 3px;
}

.add_user_btn {
  font-size: 13px;
  margin-left: 10px;
  cursor: pointer;
  color: #ccc;
}

.add_user_btn:hover {
  color: #0466dd;
}

.user_list_div {
  display: flex;
  flex-wrap: wrap;
  margin: 0 10px 10px 15px;
}

.dep_inner_box {
  margin-bottom: 10px;
  border: 1px solid #eeeeee;
}

.team_title {
  font-size: 14px;
  color: #333;
  font-weight: 600;
  margin-bottom: 10px;
  cursor: pointer;
}

.children_dep {
  margin: 10px;
  border: 1px solid #ccc;
  color: #666;
  padding: 3px 8px;
  font-size: 13px;
  cursor: pointer;
  width: 100px;
  border-radius: 3px;
}

.children_dep2 {
  margin: 10px;
  border: 1px solid #ccc;
  color: #666;
  display: flex;
  align-items: center;
  padding: 3px 8px;
  font-size: 12px;
  border-radius: 3px;
  cursor: pointer;
}

.children_dep2:hover {
  background-color: #0466dd;
  color: #fff;
}

.dep_main_div {
  padding: 10px;
  width: 100%;
  display: flex;
  align-items: center;
}

.dep_list {
  border-bottom: 10px solid #f5f7f9;
  padding: 10px 10px 0 10px;
}

.content_page {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.options_box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 10px;
}

.table_box {
  position: relative;
  height: calc(100vh - 130px);
  overflow: auto;
  padding: 0 10px;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.content {
  background-color: #fff;
  height: calc(100vh - 50px);
  overflow: auto;
}

.main {
  background: #f5f7f9;
  min-height: 100vh;
}
</style>
